module.exports = __webpack_public_path__ + "static/media/TsparticlesEffect.d.ts.9d8c6ff4.map";